<template>
  <v-container
    ref="container"
    class="fill-height page"
    fluid
  >
    <div class="overlay" />

    <v-row
      class="f-flex"
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="4"
      >
        <v-card class="elevation-12">
          <v-toolbar
            color="primary"
            dark
            flat
          >
            <v-toolbar-title>Mot de passe oublié ?</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <div v-if="sent">
              <p style="color:black">
                Vous allez recevoir un lien sur votre email permettant de réinitialiser votre mot de passe. Attention, ce lien ne sera valable qu'une heure.
              </p>
            </div>
            <div v-else>
              <p style="color:black">
                Saisissez le courriel associé à votre compte Artifex.
                Nous allons envoyer à cette adresse un lien vous permettant de réinitialiser facilement votre mot de passe.
              </p>
              <v-form @submit.prevent="send">
                <v-text-field
                  v-model="info.email"
                  label="Courriel"
                  name="email"
                  prepend-icon="mdi-account"
                  type="text"
                />
              </v-form>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="$router.push('/account/login')"
            >
              Retour à la connexion
            </v-btn>
            <v-spacer />
            <v-btn
              v-if="!sent"
              color="primary"
              dark
              :loading="inProgress"
              @click="send()"
            >
              Envoyer
            </v-btn>
          </v-card-actions>

          <v-alert
            v-if="hasError"
            dense
            outlined
            type="error"
            class="ma-3"
          >
            {{ hasError }}
          </v-alert>
          <br>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// import { AbilityBuilder } from '@casl/ability'

  import { mapGetters } from 'vuex'

  export default {
    auth: false,
    layout: 'empty',
    data: () => ({
      sent: false,
      inProgress: false,
      hasError: '',
      info: {
        email: '',
      },
    }),
    computed: {
      ...mapGetters('style', ['primaryColor', 'title', 'secondaryColor']),
    },
    mounted () {},
    methods: {
      send () {
        this.inProgress = true
        this.hasError = ''
        this.$auth.requestPassword({
          email: this.info.email,
        })
          .then(() => {
            this.inProgress = false
            this.sent = true
            // this.$router.push('/account/login')
          })
          .catch((err) => {
            this.inProgress = false
            this.hasError = 'Le nom d\'utilisateur ou le courriel n\'est pas connu.'
            console.log(err)
          })
      },
    },
  }
</script>

<style scoped>
.page {
  padding: 0!important;
  position: relative;
  background-position: center;
  background-size: cover;
  background-image: url('https://imaginary.service.codeisalie.fr/resize?height=80&url=https://storage.service.lecalamedor.fr/strapi/DSC_0173_5f06dace78.JPG');
}
.overlay {
  position: absolute;
  background: rgba(0, 0, 0, 0.7);
  height:100%;
  width:100%
}
</style>
